import { call, put, take, takeEvery, takeLatest, select } from 'redux-saga/effects'
import {
    FETCH_EVENTS, FETCH_EVENTS_LOADING, FETCH_EVENTS_ERROR, getActiveEvents, getEventBets, EVENTS_SET_ACTIVE, EVENTS_POST_BET, EVENTS_UPDATE, EVENT_UPDATE, getEventDetails, FETCH_EVENTS_SUCCESS, FETCH_EVENT, FETCH_EVENT_LOADING, FETCH_EVENT_ERROR, FETCH_EVENT_SUCCESS, FETCH_EVENT_DETAILS_BETS, getEventDetailsBets, FETCH_EVENT_DETAILS_BETS_SUCCESS, FETCH_EVENT_DETAILS_BETS_ERROR, FETCH_EVENT_DETAILS_BETS_LOADING
} from '../constants/action-types';
import { EventSchema } from '../schemas/event'

/**
 * Get a single event
 * @param {*} param0 
 */
function* fetchEvent({eventId}) {

    const events = yield select(state => state.events.events)
    yield put({type: FETCH_EVENT_LOADING })

    try {

        const response = yield call((() => firebase.functions().httpsCallable(getEventDetails)({eventId})))
        
        const eventIds = events.map(e => e.eventId),
            currentIndex = eventIds.indexOf(eventId),
            // TODO: This is weird, the eventId should just be passed in the event object, so we don't have to do this object assign thing.
            eventSchema = new EventSchema(Object.assign({}, response.data, {eventId}))
        
        if (currentIndex === -1)

            events.push(eventSchema)
        
        else events[currentIndex] = eventSchema

        
        yield put({type: FETCH_EVENT_SUCCESS, payload: events })

    } catch (e) {

        yield put({ type: FETCH_EVENT_ERROR, payload: e.message })

    } 

}

function* fetchEvents() {

    yield put({type: FETCH_EVENTS_LOADING })

    try {

        const response = yield call((() => firebase.functions().httpsCallable(getActiveEvents)()))
        // TODO: This is weird, the eventId should just be passed in the event object, so we don't have to do this object assign thing.
        yield put({type: FETCH_EVENTS_SUCCESS, payload: response.data.events.map(e => new EventSchema(Object.assign({}, e.event, {eventId: e.eventId})))})

    }
    catch (e) {

        yield put({ type: FETCH_EVENTS_ERROR, payload: e.message })

    } 

}

function* fetchEventsDetailsBets(eventId) {
    console.log(JSON.stringify(eventId.payload));

    const eventsBets = yield select(state => state.events.eventsBets)
    yield put({type: FETCH_EVENT_DETAILS_BETS_LOADING })

    try {

        const response = yield call((() => firebase.functions().httpsCallable(getEventDetailsBets)({eventId: eventId.payload.eventId})))
        
        // const eventIds = eventsBets.map(e => e.eventId),
        //     currentIndex = eventIds.indexOf(eventId),
        //     eventsBet = Object.assign({}, {eventId}, response.data)
        
        // if (currentIndex === -1)

        //     eventsBets.push(eventsBet)
        
        // else eventsBets[currentIndex] = eventsBet

        yield put({type: FETCH_EVENT_DETAILS_BETS_SUCCESS, payload: response.data })

    }
    catch (e) {
        
        yield put({ type: FETCH_EVENT_DETAILS_BETS_ERROR, payload: e.message })

    } 

}

export default [
    takeLatest(FETCH_EVENT, fetchEvent),
    takeLatest(FETCH_EVENTS, fetchEvents),
    takeLatest(FETCH_EVENT_DETAILS_BETS, fetchEventsDetailsBets)
]


// WEBPACK FOOTER //
// ./src/sagas/events.js